import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import React from "react";
import { Message as RSMessage } from "rsuite";
import { capitaliseFirstLetter } from "../general/utils";
const Message = React.forwardRef((props, ref) => {
    const { children, showIcon, closable, type, header, onClose, styles, hidePrefix, bordered, ...rest } = props;
    return (_jsx("div", { ref: ref, style: { ...styles, marginBottom: "4px" }, children: _jsxs(RSMessage, { closable: closable, showIcon: showIcon, type: type, header: header, bordered: bordered, onClose: onClose, ...rest, children: [typeof children === "string" && type && !hidePrefix && (_jsxs("strong", { children: [capitaliseFirstLetter(type), "! "] })), children] }) }));
});
export default Message;
